<template>
  <b-modal :active.sync="isActive" has-modal-card trap-focus @close="$emit('close')">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Cancelar contrato</p>
        <button type="button" class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <p class="mb-3"><strong>{{ contract.folio }}</strong> — {{ contract.organismo_nombre || contract.empresa_nombre }}</p>
        <div class="bc-field-validated">
          <b-field
            label="Motivo de la cancelación"
            :type="errors.causal_estatus ? 'is-danger' : null"
            :message="errors.causal_estatus || fieldMessageSpacer"
          >
            <b-input v-model="form.causal_estatus" type="textarea" maxlength="500"></b-input>
          </b-field>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" @click="close">Cerrar</button>
        <button class="button is-danger" :loading="loading" @click="submit">Cancelar contrato</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ContractCancelModal',
  props: {
    active: Boolean,
    contract: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      isActive: this.active,
      loading: false,
      form: { causal_estatus: '' },
      errors: {},
      fieldMessageSpacer: '\u00a0'
    };
  },
  watch: {
    active(val) { this.isActive = val; },
    isActive(val) { if (!val) this.$emit('close'); }
  },
  methods: {
    close() {
      this.isActive = false;
      this.form.causal_estatus = '';
      this.errors = {};
    },
    async submit() {
      this.loading = true;
      try {
        const { data } = await this.$http.patch(`budget-control/contracts/${this.contract.id}/cancel`, this.form);
        this.$toast.success(data.message || 'Contrato cancelado');
        this.$emit('saved');
        this.close();
      } catch ({ response }) {
        this.$toast.error(response?.data?.message || 'No se pudo cancelar el contrato');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
